/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createClassWrapper } from '../../internal/createClassWrapper.js';
import ContentSwitcher$1 from './ContentSwitcher.js';

const ContentSwitcher = createClassWrapper(ContentSwitcher$1);

export { ContentSwitcher, ContentSwitcher as default };
